export const HOMEPAGE_HERO_SEASONS = [
  'new-year',
  'valentines',
  'st-patricks',
  'independence',
  'halloween',
  'thanksgiving',
  'christmas',
] as const;

export type HomepageHeroSeason = (typeof HOMEPAGE_HERO_SEASONS)[number];
export type HomepageHeroSeasonSetting = 'auto' | 'default' | HomepageHeroSeason;

const PACIFIC_DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Los_Angeles',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

export function resolveHomepageHeroSeason(
  setting: HomepageHeroSeasonSetting,
  now: Date = new Date(),
): HomepageHeroSeason | null {
  if (setting === 'default') return null;
  if (setting !== 'auto') return setting;

  const dateParts = PACIFIC_DATE_FORMAT.formatToParts(now);
  const year = Number(dateParts.find((part) => part.type === 'year')?.value);
  const month = Number(dateParts.find((part) => part.type === 'month')?.value);
  const day = Number(dateParts.find((part) => part.type === 'day')?.value);

  if ((month === 12 && day >= 26) || (month === 1 && day <= 3)) return 'new-year';
  if (month === 2 && day >= 7 && day <= 14) return 'valentines';
  if (month === 3 && day >= 10 && day <= 17) return 'st-patricks';
  if (month === 7 && day <= 4) return 'independence';
  if (month === 10 && day >= 15) return 'halloween';
  if (month === 11) {
    // Thanksgiving is the fourth Thursday in November, not a fixed date.
    const novemberFirstWeekday = new Date(Date.UTC(year, 10, 1)).getUTCDay();
    const thanksgivingDay = 22 + ((4 - novemberFirstWeekday + 7) % 7);
    return day <= thanksgivingDay ? 'thanksgiving' : 'christmas';
  }
  if (month === 12 && day <= 25) return 'christmas';

  return null;
}
